<template>
<div style="width:100%;height:100%">
    <!--<div slot="title">
      <span style="margin-right: 12px;">生成权限表达式</span>
      <el-button type="info" @click="showHelp">
        <i class="fa fa-question"></i>帮助
      </el-button>
    </div>-->
    <el-form>
      <el-table :data="dataList" height="250" border style="width: 100%">
        <el-table-column prop="fieldValue" label="字段名称" type="index" width="280">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fieldName" placeholder="字段名称" readonly style="width: 80%;"></el-input>
            <el-button @click.prevent="selectField(scope.row, scope.$index)">选择</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="比较值" type="index" width="98">
          <template slot-scope="scope">
            <el-select v-model="scope.row.operator">
              <!--<el-option label="请选择" value=""></el-option>-->
              <el-option v-for="op in filterOperator(scope.row.fieldValue)" :key="op.name" :label="op.name" :value="op.name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="输入值" type="index" width="280">
          <template slot-scope="scope">
            <el-input v-model="scope.row.value" placeholder="输入值" :style="{width: scope.row.selectable?'80%':'100%'}"></el-input>
            <el-button v-if="scope.row.selectable" @click.prevent="selectValue(scope.row)">选择</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="logic" label="关系符" type="index" width="98">
          <template slot-scope="scope">
            <el-select v-model="scope.row.logic">
              <el-option label="并且" value="and"></el-option>
              <el-option label="或者" value="or"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div>
      <p style="margin-top: 10px; font-size: 16px; font-weight: 600;">预览:</p>
      <div style="height:30px;">
        {{generatedFormula}}
      </div>
    </div>
    <div class="dialog-footer" style="float:right;">
      <el-button @click="showHelp">帮助</el-button>
      <el-button @click="addRow">添加一行</el-button>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
      <!--<el-button type="primary" @click="showData">showData</el-button>-->
    </div>
    <el-dialog ref="selzdmc" title="选择字段名称" width="300px" :append-to-body="true" :show-close="false" :visible.sync="dialogSelectVisible">
    <div style="width: 100%; padding-top: 8px;overflow:auto;max-height:500px">
      <p v-for="field in candidateFields"><el-radio v-model="selectedField" :label="field.value">{{field.name}}</el-radio></p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogSelectVisible = false">取 消</el-button>
      <el-button type="primary" @click.prevent="setSelectedField">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
    export default {
      name: "mw-formula-generator",
      props:{
        rowData:Array,
        extraFields:Array,
        fields:Array,
      },
      data() {
        return {
          dataList:[],
          dialogSelectVisible:false,
          selectedField:"",
          //generatedFormula:"",
          candidateFields:[
            {name:"用户名称",value:"$userName"},
            {name:"身份权限",value:"$roleNames",type:'contain'},
            {name:"单位或部门",value:"$D",selectable:"dep"},
            {name:"登陆ID",value:"$loginId"}
            ],//可选的所有字段
          operators:[/*{
            name:"等于(包含子部门)",
            fn:``,
            hidden:"value !=='$D'"
          },{
            name:"不等于(包含子部门)",
            fn:row=>``,
            hidden:"value !=='$D'"
          },*/{
            name:"包含",
            fn:"contains",
            hidden:"type!=='contain'"
          },{
            name:"不包含",
            fn:"notContains",
            hidden:"type!=='contain'"
          },{
            name:"等于",
            fn:"equal",
            hidden:"type==='contain'"
          },{
            name:"不等于",
            fn:"notEqual",
            hidden:"type==='contain'"
          }
          ]
        }
      },
      mounted() {
        if (this.fields) {
          this.candidateFields=this.fields;
        }
        if (this.extraFields) {
          this.candidateFields = this.candidateFields.concat(this.extraFields);
        }
        if (this.rowData) {
          this.dataList=this.rowData;
        }else{
          this.addRow();
        }
      },
      methods:{
        showHelp() {
          PF.showHelp({url:'/helpDoc/platform/authory.md'});
        },
        addRow() {
          this.dataList.push({
            fieldValue : '',
            fieldName : '',
            fieldType:"",
            value  : '',
            displayValue :'',
            operator:"",
            logic:'and'
          })
        },
        selectField(row, scopeIndex) {
          row.fieldValue = '';
          row.fieldName = '';
          row.fieldType="";
          row.selectable=false;
          row.value = '';
          row.displayValue = '';
          row.operator='';
          this.currentSelectRow = row;
          this.dialogSelectVisible = true;
        },
        filterOperator(fieldValue) {
          let me=this;

          if(!fieldValue)return [];
          let field=me.getField(fieldValue);
          let operators=field.operators || me.operators;
          if (typeof operators === 'number') {
            operators = me.operators.filter((op, index) => operators & 1<<index);
          }
          return operators.filter(op=>{
            return op.hidden===undefined || !PF.eval(op.hidden,field,field);
          });
        },
        getField(fieldValue) {
          return this.candidateFields.filter(f => f.value===fieldValue)[0];
        },
        close() {
          if(this.$parent)this.$parent.hide();
        },
        confirm() {
          let data={
            formula:this.generatedFormula,
            rowData:this.dataList
          };
          this.$emit("ok",data);
          if(this.$parent)this.$parent.hide();
        },
        setSelectedField(){
          let row=this.currentSelectRow;
          let field=this.getField(this.selectedField);
          if (field && row) {
            row.fieldValue = this.selectedField;
            row.fieldName = field.name;
            row.selectable=!!field.selectable;
            row.fieldType=field.type;
          }
          this.currentSelectRow="";
          this.selectedField="";
          this.dialogSelectVisible = false;
        },
        getValueSelections(row) {
          let field=this.getField(row.fieldValue);
          return field && field.selections;
        },
        genFormula() {
          let me=this;
          if(!me.dataList || me.dataList.length===0)return "";
          return me.dataList.map((row,index) => {
            if(!row.fieldValue || !row.value || !row.operator)return "";
            let opr=me.operators.filter(o=>o.name===row.operator)[0];
            if(!opr) throw Error("没有找到对应的操作");
            if(!opr.fn)throw Error(`未设置操作[${opr.name}]的处理函数。`);
            let formula=me.getRowFormula(row,opr);
            let logicMap={"and":" && ","or":" || "};
            if(index<me.dataList.length-1) formula += logicMap[row.logic] || ""
            return formula;
          }).join("");
        },
        getRowFormula(row,opr) {
          let field=this.getField(row.fieldValue);
          let fnMap={
            equal:(row)=>{
              return field.dataType!=="boolean"?
                `${row.fieldValue}==="${row.value}"`:
                (row.value!=="true"?"!":"")+row.fieldValue
            },
            notEqual:row=>{
              return field.dataType!=="boolean"?
              `${row.fieldValue}!=="${row.value}"`:
                (row.value==="true"?"!":"")+row.fieldValue
            },
            contains:row=>`$contains(${row.fieldValue},"${row.value}")`,
            notContains:row=>`!$contains(${row.fieldValue},"${row.value}")`
          }
          if (typeof opr.fn === 'string') {
            let fn = fnMap[opr.fn];
            if (fn) {
              return fn(row);
            } else {
              throw Error(`未设置操作[${opr.name}]的处理函数。`);
            }
          } else {
            return opr.fn(row);
          }
        },
      /*  showData() {
          console.log(this.dataList)
        },*/
        selectValue(row) {
          let me=this;
          let field=this.getField(row.fieldValue);
          let selectType=field.selectable;
          if (!selectType) {
            return;
          }
          if (typeof selectType === "string") {
            let handlerMap={
              "dep":me.selectDepartment
            };
            selectType=handlerMap[selectType]
          }else if ($.isArray(selectType)) {
            let selections=selectType;
            selectType=function(row,callback){
              PF.treeSelect({data: selections}, (data) => {
                data=data || {};
                callback({value:data.value || data.id, displayValue: data.name || data.text});
              });
            }
          }

          if ($.isFunction(selectType)) {
            selectType.call(me,row,function(data){
              row.value=data.value;
              row.displayValue=data.displayValue;
            });
          }
        },
        selectDepartment(row,callback){
          let selectNode = row.value;
          let defaultParams = {};
          var curUrl = this.mwUrl("/api/org/listDepartment");
          if (!this.userInfo || !this.userInfo.developer) curUrl = this.mwUrl("/api/org/listDepartmentListAble");
          PF.show('tree',{
            url: curUrl,
            defaultParams: defaultParams,
            selectNode:selectNode,
            types:{
              "1": {
                "icon": "fa fa-folder"
              },
              "2": {
                "icon": "fa fa-leaf"
              },
              "3": {
                "icon": "fa fa-users"
              },
              'default':{
                "icon": "fa fa-leaf"
              }
            },
            search: false,
            multiple:false,
            singleLeaf:false,
            clearBtn:true
          },(res) => {
              callback({value:res.id,displayValue:res.name});
          });
        }
      },
      computed:{
        generatedFormula() {
          return this.genFormula()
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/components/extend/formula-generator/index.vue